import Head from 'next/head';

import { HOMEPAGE_URL } from '../../helpers/globals';
import { MarketInfo } from './map/types';
import { ActiveMarket } from './types';

interface MarketplaceSeoHeadProps {
  marketInfo: MarketInfo;
  activeMarkets: ActiveMarket[];
  canonicalOverride?: string;
}

export const MarketplaceSeoHead: React.FC<MarketplaceSeoHeadProps> = ({
  marketInfo,
  activeMarkets,
  canonicalOverride,
}) => {
  const marketDisplayName = marketInfo.displayName || marketInfo.name;
  const currentMarket = activeMarkets.find(
    (m) => m.identifier === marketInfo.identifier || m.displayName === marketDisplayName,
  );
  const stateAbbreviation = currentMarket?.displayState || '';
  const locationText = stateAbbreviation
    ? `${marketDisplayName}, ${stateAbbreviation}`
    : marketDisplayName;

  const pageTitle = `Houses for sale in ${marketDisplayName} | Opendoor`;
  const pageDescription = `Explore houses for sale in ${locationText} with Opendoor. Get instant access to listings, photos, and home details, and schedule self-guided tours today.`;
  const canonicalPath = canonicalOverride ?? `/homes/${marketInfo.name.toLowerCase()}`;
  const canonicalUrl = `${HOMEPAGE_URL}${canonicalPath}`;

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonicalUrl} />
    </Head>
  );
};
